import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SlideGeneratorComponent } from './slide-generator/slide-generator.component';
@NgModule({
  declarations: [SlideGeneratorComponent],
  imports: [CommonModule, RouterModule, TranslateModule, NgbModule],
  exports: [SlideGeneratorComponent],
})
export class SharedModule {}
